module.exports = __webpack_public_path__ + "static/media/alternateBackgroundMoreThanSix.dd96f8dd.png";